import { render } from "./en.vue?vue&type=template&id=5ed99b8c&scoped=true"
import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"

import "./en.vue?vue&type=style&index=0&id=5ed99b8c&scoped=true&lang=css"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed99b8c"]])

export default __exports__